import { memo, type JSX } from 'react';

import styled from '@mint-lib/styled';

type Props = {
  header: JSX.Element | null;
  notificationList: JSX.Element;
  pagination: JSX.Element;
  shouldHidePagination: boolean;
};

const CarbonNeutralTemplate = ({
  header,
  notificationList,
  pagination,
  shouldHidePagination,
}: Props) => {
  return (
    <Wrapper>
      <HeaderWrapper>{header}</HeaderWrapper>
      <ListWrapper>{notificationList}</ListWrapper>
      {!shouldHidePagination ? (
        <PaginationWrapper>{pagination}</PaginationWrapper>
      ) : null}
    </Wrapper>
  );
};

const HeaderWrapper = styled('div')`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

const PaginationWrapper = styled('div')`
  display: flex;
  justify-content: flex-start;
`;

const ListWrapper = styled('div')`
  height: 100%;
  overflow-y: auto;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 1286px;
  height: ${window.innerHeight - 150}px;
  justify-content: space-between;
`;

export default memo(CarbonNeutralTemplate);
